import { render, staticRenderFns } from "./TypeNonConformance.vue?vue&type=template&id=2e61a184&"
import script from "./TypeNonConformance.vue?vue&type=script&lang=js&"
export * from "./TypeNonConformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports